
import { fetchGiftCards, createSubscriptionGift, updateGiftAndStripePaymentOrderOnSuccess, fetchGiftBanners, retrieveSubscriptionGift, setupStripeSubscriptionFromSubscriptionGift, setupStripeIntent, linkMaxAgeGiftToMembership } from '../../clients/subscription-gift'
import { fromStrapiSubscriptionGift } from '../../helpers/mapping/subscription-gift'
import { fromStrapiGiftBanners } from '../../helpers/mapping/subscription-gift-banner'
import { fromStrapiGiftCard } from '../../helpers/mapping/subscription-gift-card'
import { GiftBanners, GiftCard, SubscriptionGift } from '../../types'

class SubscriptionGiftRepository {
    async retrieveGiftCards(): Promise<GiftCard[]> {
        const giftCardResponse = await fetchGiftCards()
        const giftCards = giftCardResponse.data.map(fromStrapiGiftCard)
        return giftCards
    }

    async retrieveGiftBanners(): Promise<GiftBanners> {
        const giftBannersResponse = await fetchGiftBanners()
        return fromStrapiGiftBanners(giftBannersResponse.data)
    }

    async createSubscriptionGift(subscriptionGift: SubscriptionGift) {
        return createSubscriptionGift(subscriptionGift)
    }

    async setupStripeSubscriptionFromSubscriptionGift(giftCode: string, exchangeId?: string) {
        return await setupStripeSubscriptionFromSubscriptionGift(giftCode, exchangeId)
    }

    async linkMaxAgeGiftToMembership(giftCode: string, exchangeId?: string) {
        return await linkMaxAgeGiftToMembership(giftCode, exchangeId)
    }

    async setupStripeIntent(exchangeId: string) {
        return await setupStripeIntent(exchangeId)
    }

    async updateGiftAndStripePaymentOrderOnSuccess(giftCode: string ) {
        return await updateGiftAndStripePaymentOrderOnSuccess(giftCode)
    }

    async retrieveSubscriptionGift(giftCode: string) : Promise<SubscriptionGift> {
        const subscriptionGiftResponse = await retrieveSubscriptionGift(giftCode)
        return fromStrapiSubscriptionGift(subscriptionGiftResponse)
    }
}

export default SubscriptionGiftRepository